import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MealEntity } from '../../domain/entities/MealEntity'
import type { MealAdminDto } from '@/backend/market'
export class MealModel extends MealEntity {
  constructor(dataDto: MealAdminDto) {
    super()
    mapEntityProperties<MealEntity>(this, dataDto)
  }
}
